import React, { useState, useRef, useEffect } from 'react'
import { FAIL, LOADING, SUCCESS } from '../../redux_store/actionTypes';
import Button from '../templates/Button';
import InputField from '../templates/InputField'
import { useSelector, useDispatch } from 'react-redux'
import LoadingModal from '../templates/modals/LoadingModal';
import { displayFile } from '../../utils';
import PasswordResetModal from '../templates/modals/PasswordResetModal';
import { getAdminDetails } from '../../redux_store/asyncConfig';
import { passwordReset, updateAdminProfile } from '../../redux_store/auth/auth_thunk';
import toast from '../templates/ToastMessage';
import { clearAuthState } from '../../redux_store/auth/auth_slice';

const ProfilePage = () => {
  const { status, message } = useSelector((state)=>state.auth);
  const dispatch = useDispatch();
  const imageRef = useRef(null);
  const profilePicRef = useRef(null);  
  const [showPasswordResetModal, setShowPasswordResetModal] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [details, setDetails] = useState({});
  const [credentials, setCredentials] = useState({});

  useEffect(()=>{
    dispatch(clearAuthState())
    const user = getAdminDetails();
    if(user){
      displayFile(user.profile_pic, profilePicRef.current);
      setDetails(user);
    }
    // eslint-disable-next-line
  }, []);

  useEffect(()=>{
    if(status === FAIL){
      toast({message, status});
    }else if(status === SUCCESS){
      setEditMode(false);
      toast({message, status});
    }
    dispatch(clearAuthState())
    // eslint-disable-next-line
  }, [status]);

  const handleFormSubmit = (e) => {
    e.preventDefault();
    if(showPasswordResetModal){
      if(credentials.new_password !== credentials.confirm_password){
        toast({message: 'New Password and Confirm password should be same', status: 'fail'})
      }else{
        dispatch(passwordReset(credentials));
      }
    }else{
      dispatch(updateAdminProfile(details));
    }
  }

  const handleInputChange = (e) => {
    const {name, value} = e.target;
    if(showPasswordResetModal){
      setCredentials({...credentials, [name]:value});
    }else{
      setDetails({...details, [name]:value});
    }
  }

  const handleImageSelect = () => {
    const image = imageRef.current;
    image.click();
    image.addEventListener('change', (e)=>{
      setDetails({...details, profile_pic :image.files[0]});
      displayFile(image.files[0], profilePicRef.current);
    })
  }
  
  return (
    <>
      {showPasswordResetModal &&       
        <PasswordResetModal 
          onSubmit={handleFormSubmit}
          onInputChange={handleInputChange}
          onCancel={()=>setShowPasswordResetModal(false)}
          credentials={credentials}
        />
      }
    <form onSubmit={handleFormSubmit} className='grid gap-y-5 gap-x-8 py-10 px-16 grid-cols-2 bg-white shadow-md rounded'>
      {status === LOADING && <LoadingModal message={'Please wait...'} />}
      <input type={'file'} ref={imageRef} name="profile_pic" hidden />
      <div className='col-span-2 grid grid-cols-3'>
        <div className='border flex flex-col border-gray-400 shadow-md h-48'>
          <div ref={profilePicRef} className="w-full h-full"></div>
          {editMode &&          
            <button type='button' onClick={handleImageSelect} className='w-full z-10 bg-gray-200 py-1'>change image</button>
          }
        </div>
        <div className='col-start-3 flex justify-end items-end space-x-2'>
          <button type='button' onClick={()=>{
            setEditMode(true);
          }} className='text-sm text-gray-900 font-bold border py-2 px-3 bg-yellow-500 rounded-md'>Edit Details</button>
          <button type='button' onClick={()=>{
            setShowPasswordResetModal(true);
          }} className='text-sm text-gray-900 font-bold border py-2 px-3 bg-yellow-500 rounded-md'>Change Password</button>
        </div>
      </div>

      <div>
        <p className='text-gray-500 font-medium text-sm'>Firstname</p>
        <InputField 
          type={'text'}
          name="firstname"
          disable={!editMode}
          isRequired={true}
          onChange={handleInputChange}
          value={details.firstname}
          placeholder="Enter firstname" 
        />
      </div>
      <div>
        <p className='text-gray-500 font-medium text-sm'>Lastname</p>
        <InputField 
          type={'text'}
          disable={!editMode}
          name="lastname"
          isRequired={true}
          onChange={handleInputChange}
          value={details.lastname}
          placeholder="Enter lastname" 
        />
      </div>
      <div>
        <p className='text-gray-500 font-medium text-sm'>Email Address</p>
        <InputField 
          type={'email'}
          name="email"
          isRequired={true}
          disable={!editMode}
          onChange={handleInputChange}
          value={details.email}
          placeholder="Enter email" 
        />
      </div>
      <div>
        <p className='text-gray-500 font-medium text-sm'>Phone Number</p>
        <InputField 
          type={'text'}
          name="phone_number"
          isRequired={true}
          disable={!editMode}
          onChange={handleInputChange}
          value={details.phone_number}
          placeholder="Enter phone number" 
        />
      </div>
      <div className='col-span-2'>
        {editMode &&         
          <Button
            type="submit"
            label={'Update'}
            width="w-full"
            bgColor={'wayrideBgColor'}
          />
        }
      </div>
    </form>
    </>
  )
}

export default ProfilePage